/**
 * Run `callback` once the user has granted marketing consent — immediately if
 * already granted, otherwise the first time the marketing category flips to
 * true. Use this to gate marketing/tracking scripts (Klaviyo, Clarity,
 * Optimizely, …) so nothing fetches before consent (AGENTS.md rule #4).
 *
 * Fires the callback at most once per call site. Client-only: call from
 * `*.client.ts` plugins (the watcher is not tied to a component lifecycle).
 *
 * Thin wrapper over `useConsentCategory("marketing", …)` — reach for that
 * directly to gate on `statistics`/`preferences`, or to react to consent
 * being withdrawn as well as granted.
 */
export const useMarketingConsent = (callback: () => void): void => {
	useConsentCategory("marketing", callback);
};
